const VERSION = "11.3.1";
export {
  VERSION
};
